import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
export default class CategoryResultsModal extends Modal {
  className() {
    return 'HFAwardsModal CategoryResultsModal';
  }
  title() {
    const category = this.attrs.category;
    return m("span", null, category.name(), " - ", app.translator.trans('huseyinfiliz-awards.forum.results.full_results'));
  }
  content() {
    const category = this.attrs.category;
    const award = this.attrs.award;
    const nominees = category.nominees() || [];

    // Sort by vote count descending
    const sortedNominees = [...nominees].sort((a, b) => (b.voteCount() || 0) - (a.voteCount() || 0));

    // Calculate total votes for percentages
    const totalVotes = sortedNominees.reduce((sum, n) => sum + (n.voteCount() || 0), 0);
    const canShowVotes = award.canShowVotes();
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "CategoryResultsModal-list"
    }, sortedNominees.map((nominee, index) => {
      const voteCount = nominee.voteCount() || 0;
      const percentage = totalVotes > 0 ? Math.round(voteCount / totalVotes * 100) : 0;
      const isWinner = index === 0;
      const isRunnerUp = index === 1;
      const isThird = index === 2;
      return m("div", {
        className: `CategoryResultsModal-item ${isWinner ? 'CategoryResultsModal-item--winner' : ''}`,
        key: nominee.id()
      }, m("div", {
        className: "CategoryResultsModal-item-rank"
      }, isWinner ? m("span", {
        className: "CategoryResultsModal-medal CategoryResultsModal-medal--gold"
      }, m("i", {
        className: "fas fa-medal"
      })) : isRunnerUp ? m("span", {
        className: "CategoryResultsModal-medal CategoryResultsModal-medal--silver"
      }, m("i", {
        className: "fas fa-medal"
      })) : isThird ? m("span", {
        className: "CategoryResultsModal-medal CategoryResultsModal-medal--bronze"
      }, m("i", {
        className: "fas fa-medal"
      })) : m("span", {
        className: "CategoryResultsModal-rankNumber"
      }, index + 1)), m("div", {
        className: "CategoryResultsModal-item-nominee"
      }, nominee.imageUrl() ? m("img", {
        className: "CategoryResultsModal-item-image",
        src: nominee.imageUrl(),
        alt: nominee.name()
      }) : m("div", {
        className: "CategoryResultsModal-item-placeholder"
      }, m("i", {
        className: "fas fa-user"
      })), m("span", {
        className: "CategoryResultsModal-item-name"
      }, nominee.name())), canShowVotes ? m("div", {
        className: "CategoryResultsModal-item-stats"
      }, m("span", {
        className: "CategoryResultsModal-item-votes"
      }, voteCount), m("div", {
        className: "CategoryResultsModal-item-bar"
      }, m("div", {
        className: "CategoryResultsModal-item-barFill",
        style: {
          width: `${percentage}%`
        }
      })), m("span", {
        className: "CategoryResultsModal-item-percentage"
      }, percentage, "%")) : null);
    })));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/CategoryResultsModal', CategoryResultsModal);